module.exports = __webpack_public_path__ + "c25ca2e22132a517dd4f6bd43f56e5d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-10.png
// module id = 1163
// module chunks = 0